import { NewCasinoGame } from 'interfaces/new-casino';
import store from 'store';

type TGameId = NewCasinoGame['id'];

export const checkIsGameAlreadyCached = (gameId: TGameId) => {
  const storeState = store.getState();
  const cachedGames = storeState.newCasinoStore.cachedGames;

  return !!cachedGames[gameId]?.data;
};
